import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import Services from './Services';
import CarSearchSection from './CarSearchSection';
import AboutUs from './AboutUs';
import Service2 from './Services2';
import Contact from './Contact';
import Footer from './Footer';
import CryptoPay from './CryptoPay';
import StepsPay from './StepsPay';
import OffMarketSection from './OffMarketSection';


const Home = () => {
  return (
    <>
      <div className="min-h-screen bg-black">
        <Navbar />
        <Hero />
        <Services />
        <CarSearchSection />
        <OffMarketSection />
        <AboutUs />
        <Service2 />
        <CryptoPay />
        <StepsPay />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default Home;
